module.exports = __webpack_public_path__ + "img/Cipla (1).19770c1a.png";